import html2canvas from 'html2canvas';

import {
    CHART_CONTENT_CLASSNAME,
    CHART_LABEL_CLASSNAME,
    CHART_LEGEND_CLASSNAME,
    CHOROPLETH_LEGEND_CLASSNAME,
} from '../../Chart';
import styles from '../ChartPropProvider.module.css';


export const addLegend = async (svgContainer: SVGElement) => {
    const foreignObj = svgContainer.querySelector(`.${CHOROPLETH_LEGEND_CLASSNAME}`);
    let choroplethWrapper = svgContainer.querySelector(`.${CHART_CONTENT_CLASSNAME}`)?.parentElement;
    if (!foreignObj || !choroplethWrapper) {
        return;
    }

    const container = document.createElement('div');
    container.innerHTML = foreignObj.innerHTML;

    const parent = svgContainer.parentElement;
    if (!parent) {
        container.remove();
        return;
    }
    const containerFirstChild = container.firstChild as HTMLElement;
    if (!containerFirstChild) {
        container.remove();
        return;
    }
    container.className = styles.svgLegendContainer;
    containerFirstChild.className = styles.svgLegendContent;
    parent.appendChild(container);

    const { height, width } = containerFirstChild.getBoundingClientRect();
    const { height: contentHeight } = choroplethWrapper.getBoundingClientRect();
    const canvas = await html2canvas(containerFirstChild);

    const clonedSvg = svgContainer.cloneNode() as SVGElement;
    clonedSvg.innerHTML = svgContainer.innerHTML;

    const newHeight = contentHeight + height + 16;
    clonedSvg.setAttribute('height', `${newHeight}`);
    clonedSvg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');

    const imgUrl = canvas.toDataURL('image/png', 1);
    if (!imgUrl) {
        container.remove();
        clonedSvg.remove();
        canvas.remove();
        return;
    }

    const image = document.createElement('image');
    image.setAttribute('href', imgUrl);
    image.setAttribute('x', '0');
    image.setAttribute('y', `${contentHeight + 16}`);
    image.setAttribute('width', `${width}`);
    image.setAttribute('height', `${height}`);
    clonedSvg.appendChild(image);

    choroplethWrapper = clonedSvg.querySelector(`.${CHART_CONTENT_CLASSNAME}`)?.parentElement;
    choroplethWrapper?.setAttribute('y', '0');

    return { svg: clonedSvg, image, container, canvas };
};

export const addRegularLegend = async (svgContainer: SVGElement) => {
    const foreignObj = svgContainer.querySelector(`.${CHART_LEGEND_CLASSNAME}`);
    let chartWrapper = svgContainer.querySelector(`.${CHART_CONTENT_CLASSNAME}`)?.parentElement;
    if (!foreignObj || !chartWrapper) {
        return;
    }

    const container = document.createElement('div');
    container.innerHTML = foreignObj.innerHTML;

    const parent = svgContainer.parentElement;
    if (!parent) {
        container.remove();
        return;
    }
    const containerFirstChild = container.firstChild as HTMLElement;
    if (!containerFirstChild) {
        container.remove();
        return;
    }
    container.className = styles.svgLegendContainer;
    containerFirstChild.className = styles.svgLegendContent;
    parent.appendChild(container);

    const { height, width } = containerFirstChild.getBoundingClientRect();
    const { height: contentHeight } = chartWrapper.getBoundingClientRect();
    const canvas = await html2canvas(containerFirstChild);

    const clonedSvg = svgContainer.cloneNode() as SVGElement;
    clonedSvg.innerHTML = svgContainer.innerHTML;

    // Remove the legend mask rect so the legendComponent SVG labels are visible in export
    clonedSvg.querySelector('[data-legend-mask]')?.remove();

    const newHeight = contentHeight + height + 16;
    clonedSvg.setAttribute('height', `${newHeight}`);
    clonedSvg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');

    const imgUrl = canvas.toDataURL('image/png', 1);
    if (!imgUrl) {
        container.remove();
        clonedSvg.remove();
        canvas.remove();
        return;
    }

    const image = document.createElement('image');
    image.setAttribute('href', imgUrl);
    image.setAttribute('x', '0');
    image.setAttribute('y', `${contentHeight + 16}`);
    image.setAttribute('width', `${width}`);
    image.setAttribute('height', `${height}`);
    clonedSvg.appendChild(image);

    chartWrapper = clonedSvg.querySelector(`.${CHART_CONTENT_CLASSNAME}`)?.parentElement;
    chartWrapper?.setAttribute('y', '0');

    return { svg: clonedSvg, image, container, canvas };
};

export const getChartLabel = async (svgContainer: SVGElement) => {
    const labelContainer = svgContainer.querySelector(`.${CHART_LABEL_CLASSNAME}`);
    if (!labelContainer) {
        return;
    }

    const { height, width } = labelContainer.getBoundingClientRect();
    const canvas = await html2canvas(labelContainer as HTMLElement);

    const imgUrl = canvas.toDataURL('image/png', 1);
    if (!imgUrl) {
        canvas.remove();
        return;
    }

    const image = document.createElement('image');
    image.setAttribute('href', imgUrl);
    image.setAttribute('x', '32');
    image.setAttribute('y', '0');
    image.setAttribute('width', `${width}`);
    image.setAttribute('height', `${height}`);

    const svg = createSvgWrapper();
    svg.appendChild(image);
    svg.setAttribute('width', `${width}`);
    svg.setAttribute('height', `${height}`);

    return { svg, canvas, image };
};

export const createSvgWrapper = () => {
    const svg = document.createElement('svg');
    svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');

    // @ts-ignore
    return svg as SVGSVGElement;
};

export const svgElementSize = (el: SVGSVGElement) => {
    const width = Number(el.getAttribute('width'));
    const height = Number(el.getAttribute('height'));

    return { width, height };
};